import { render, staticRenderFns } from "./ActionOpenChatIntroduce.vue?vue&type=template&id=39997596"
import script from "./ActionOpenChatIntroduce.vue?vue&type=script&lang=js"
export * from "./ActionOpenChatIntroduce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports